import { useNavigate } from "react-router-dom";

import eyeIcon from "../../../assets/icons/eyeicon.svg";
import { getImage } from "../../../utils/utils";
import BusinessPosTooltipBtn from "../../shared/BusinessPosTooltipBtn";
import CurrentActiveBtn from "../../shared/CurrentActiveBtn";
import CurrentBannedBtn from "../../shared/CurrentBannedBtn";
import CuurentStateBtn from "../../shared/CuurentStateBtn";

const BusinessCard = ({ rowData }) => {
  const navigate = useNavigate();

  const handleBusinessInfo = (id) => {
    navigate(`/business/${rowData.business_type}/${rowData.id}`);
  };

  return (
    <div className="bg-primary-10 py-2 px-4 rounded-[16px] flex flex-col gap-1  items-center shadow-lg border  ">
      <div className="flex justify-between items-center w-full">
        <div className=" flex-center items-top gap-1  text-dark  ">
          <img
            width={32}
            height={32}
            src={rowData.logo ? getImage(rowData.logo_preview) : "/images/briefcase.svg "}
            alt="*"
          />
          <p className="max-w-[200px] truncate text-[16px]  font-semibold">{rowData?.fa_name}</p>
        </div>
        <div className="flex items-center">
          <BusinessPosTooltipBtn value={rowData.pose_specific} />
          <button
            onClick={() => handleBusinessInfo()}
            className="flex flex-col w-fit justify-center items-center whitespace-nowrap  hover:bg-primary-100 px-1 my-1 text-dark rounded-md disabled:bg-secondary-30 disabled:text-black"
          >
            <img src={eyeIcon} alt="editIcon" className="white-img " />
          </button>
        </div>
      </div>

      <div className="mt-2  flex flex-col gap-1 items-center w-full">
        <div className="flex flex-col text-dark gap-1  w-full rounded-[16px] text-title-sm-regular">
          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              نوع کسب‌وکار
            </label>

            {rowData.business_type === "real" ? "حقیقی" : "حقوقی"}
          </div>

          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              صنف:
            </label>
            {rowData.category_title}
          </div>
          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              موجودی
            </label>
            {Number(rowData.available_balance).toLocaleString()}
          </div>
        </div>
      </div>
      <hr className="bg-neutral-20 h-[2px] text-neutral-20 w-full" />
      <div className="flex gap-2 mt-auto flex-col w-full ">
        <div className="flex justify-end gap-2 items-center w-full ">
          <div className="flex justify-center items-center flex-col gap-1">
            <p className="text-[8px] text-neutral-50">وضعیت ادمین</p>
            <CuurentStateBtn state={rowData?.approval_status} />
          </div>
          <div className="flex justify-center items-center flex-col gap-1">
            <p className="text-[8px] text-neutral-50">وضعیت کسب‌وکار</p>
            <CurrentActiveBtn state={rowData?.active} />
          </div>
          <div className="flex justify-center items-center flex-col gap-1">
            <p className="text-[8px] text-neutral-50">وضعیت مسدودی</p>
            <CurrentBannedBtn state={rowData?.banned} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCard;
